import { Kefir as K } from "kefir";

export default element =>
  K.merge([
    element.events("mouseenter").map(() => true),
    element.events("mouseleave").map(() => false)
  ]).toProperty(() => false);



// WEBPACK FOOTER //
// ./app/javascript/modules/hovered.js